import React, { useState, useEffect } from "react";
// components
import DevicePreview from "./DevicePreview";
import GeneralData from "./GeneralData";
import MessageRcs from "./Message";
import Scheduler from "../Scheduler";
import MessageText from "./MessageText";
import _ModalConfirmRcs from "../../modal/_ModalConfirmRcs";
// form
import { useFormik, FormikProvider } from "formik";
import { validationSchema } from "./validationSchema";
// utils
import { httpClient } from "../../../utils/HttpClient";
import { ApiEndpoint } from "../../../utils/ApiEndpoint";
import { errorLabels, generateRandomUUID } from "../../../utils/helpers";
import CreateMessageRcs from "../../../utils/classes/create-message-rcs";
// context
import { useAuth } from "../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
// toast
import { SuccessMessage, ErrorMessage } from "../../../utils/toastify";
import Template from "../Template";
import ShortUrls from "../multichannel/ShortUrls";

const CampaignRcsForm = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  let { token, uid_partner, uid_user } = auth.getSessionData();
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const initialValues = {
    partner: uid_partner,
    uidUser: uid_user,
    uuid_campaign: generateRandomUUID(),
    campaignName: "",
    uiddatabase: "",
    rcsmessage: "",
    rcstemplate: "",
    fallback: "",
    template_fallback: "",
    parameters: "",
    dateSend: "",
    proghour: "",
    isScheduled: false,
    title_rcs_message: "",
    step: 1,
    buttonActions: [],
    buttonQuickReplies: [],
    fieldsInfo: [],
    listShortLinks: [],
    listDatabases: [],
    imageUrl: "",
    thumbnail_url: "",
    height: "",
    carrousel: [],
    cardOrientation: "",
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnMount: false,
    validateOnChange: true,
    onSubmit: async (values) => {
      setIsLoading(true);

      try {
        await _action(values);
        SuccessMessage("Campaña enviada con éxito");
        formik.resetForm();
        navigate("/Campaigns");
      } catch (error) {
        let message = error?.message || "Error al enviar la campaña";
        ErrorMessage(`${message}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  const _action = async (values) => {
    /*eslint-disable no-unused-vars */
    let uri = "createCampaign";

    if (values.isScheduled) {
      uri = "programCampaign";
    }
    const URICustomer = `${ApiEndpoint}campaigns/${uri}`;

    const messageData = new CreateMessageRcs(values);

    const data = messageData.buildData();

    const res = await httpClient("POST", URICustomer, data, token);

    if (res?.data?.error) {
      const error =
        res.data.Errorcode === "0"
          ? "No cuenta con SMS suficientes para la campaña"
          : "Ya existe una campaña con ese nombre";
      throw new Error(error);
    }

    return res;
  };

  const getListDatabase = (uid_partner) => {
    httpClient(
      "POST",
      `${ApiEndpoint}campaigns/getPartnerDatabasesActive`,
      {
        id: `${uid_partner}`,
        iduser: uid_user,
      },
      token,
    ).then((response) => {
      formik.setFieldValue("listDatabases", response.data, false);
    });
  };

  const getShortLinks = () => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/shortLinks/${uid_partner}`,
      {},
      token,
    ).then((response) => {
      formik.setFieldValue(
        "listShortLinks",
        response.data.filter((x) => x.active),
        false,
      );
    });
  };

  const getExtraFieldsInfo = (uidDatabase) => {
    httpClient(
      "GET",
      `${ApiEndpoint}campaigns/fieldsdatabase/${uidDatabase}`,
      {},
      token,
    ).then((response) => {
      formik.setFieldValue("fieldsInfo", response.data, false);
    });
  };

  useEffect(() => {
    getListDatabase(uid_partner);
    getShortLinks();
  }, []);

  useEffect(() => {
    if (formik.values.uiddatabase !== "") {
      getExtraFieldsInfo(formik.values.uiddatabase);
    }
  }, [formik.values.uiddatabase]);

  const onValidate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);
      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }

      setVisible(true);
    } catch (error) {
      setVisible(false);
      ErrorMessage(error.message);
    }
  };


  const handleTemplate = (item) => {
    formik.setFieldValue("rcsmessage", item);
    formik.setFieldValue("fallback", item);
  };

  useEffect(() => {
    formik.setFieldValue("buttonActions", []);
    formik.setFieldValue("buttonQuickReplies", []);
  }, [formik.values.step]);
  return (
    <FormikProvider value={formik}>
      <div className="grid grid-cols-12 gap-2">
        <div className="col-span-12 md:col-span-7 lg:col-span-9 space-y-2">
          <GeneralData />
          <div className="grid grid-cols-2 gap-2">
            <Template
              onChange={handleTemplate}
              value={formik.values.rcsmessage}
            />
            <ShortUrls
              onChange={(e) => {
                formik.setFieldValue("rcsmessage", e);
                formik.setFieldValue("fallback", e);
              }}
              value={formik.values.rcsmessage}
            />
          </div>

          <MessageRcs />
          <MessageText />
          <Scheduler isLoading={isLoading} onValidate={onValidate} />
        </div>
        <div className="col-span-12 md:col-span-5 lg:col-span-3 px-4">
          <DevicePreview />
        </div>
      </div>

      <_ModalConfirmRcs
        visible={visible}
        onClose={() => setVisible(false)}
        onAction={async () => {
          await formik.submitForm();
        }}
        title="Confirmar Envío"
        description="¿Estás seguro de enviar la campaña?"
        isLoading={isLoading}
        data={formik.values}
      />
    </FormikProvider>
  );
};

export default CampaignRcsForm;
